import {FormControl, InputLabel, NativeSelect} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {Building, Room} from "../../API";
import {useMainApplicationContext} from "../../hooks/useMainApplicationContext";
import {useTranslation} from "react-i18next";
import {usePermissionHelper} from "../../hooks/usePermissionHelper";

interface Props {
    rooms: [] | Room []
}

const RoomManagerAdminForm: React.FC<Props> = (props) => {
    const {
        selectedBuildingInventory,
        setSelectedBuildingInventory
    } = useMainApplicationContext()

    let {rooms} = props

    const [listOfManagedBuildings, setListOfManagedBuildings] = useState<Building[]>([]);
    const {currentUser, managedBuildings} = useMainApplicationContext();
    const {hasManagementForBuilding} = usePermissionHelper();

    useEffect(() => {
        setListOfManagedBuildings(currentUser.isAdmin ? managedBuildings : managedBuildings.filter(building => hasManagementForBuilding(building)))
    }, [managedBuildings]);

    const {t} = useTranslation();
    return (
        <FormControl style={{width: "100%"}}>
            <InputLabel shrink htmlFor="org-unit">
                {t("general_building-singular")}
            </InputLabel>
            <NativeSelect
                value={selectedBuildingInventory?.buildingId}
                onChange={(e) => {
                    const building = listOfManagedBuildings.find(building => building.buildingId === e.target.value);
                    setSelectedBuildingInventory(building)
                }}
                data-testid={"select-org-unit"}
            >
                {listOfManagedBuildings.map((building: Building) => {
                    return <option
                        key={building.buildingId}
                        value={building.buildingId}
                        data-testid={"building-dropdown-option-" + building.buildingName}>
                        {building.buildingName}
                    </option>
                })}
                {rooms.map((r: Room) => r.orgUnitId).includes("keine") &&
                    <option
                        key={"keine"}
                        value={"keine"}
                        data-testid={"org-dropdown-option-keine"}>
                        {"ohne Org-Einheit"}
                    </option>
                }
            </NativeSelect>
        </FormControl>
    )
}

export default RoomManagerAdminForm
